//#region Function

/**
 * Use in HCP Detail Page
 * @param {RoleCategoryType} roleCategoryType
 * @param {*} rolePermission
 * @returns [] (Array of Permission's keys)
 */

export function getAllowedPermissions(roleCategoryType, rolePermission) {
    if (!roleCategoryType || !rolePermission?.permissions?.length) {
        return []
    }

    const permissionList = rolePermission.permissions.find(
        item => item.roleCategory === roleCategoryType,
    )

    if (!permissionList) {
        return []
    }

    return Object.keys(permissionList).filter(key => permissionList[key])
}

export const getRoleCategory = pathname => {
    if (pathname.includes('patients')) {
        return 'patientManagement'
    } else if (pathname.includes('hcp')) {
        return 'hcpManagement'
    } else if (pathname.includes('pathway')) {
        return 'pathwayManagement'
    } else if (pathname.includes('generalPractitioner')) {
        return 'generalPractitionerManagement'
    } else if (pathname.includes('support-teams')) {
        return 'supportTeamsManagement'
    } else return ''
}
//#endregion

//#region Constants
export const RoleCategoryType = {
    hcpManagement: 'hcpManagement',
    patientManagement: 'patientManagement',
    pathwayManagement: 'pathwayManagement',
    supportTeamsManagement: 'supportTeamsManagement',
    generalPractitionerManagement: 'generalPractitionerManagement',
}

export const RoleActionType = {
    generalPractitionerManagement: {
        allowToAdd: 'allowToAdd',
        allowToEdit: 'allowToEdit',
        allowToDelete: 'allowToDelete',
    },
    pathwayManagement: {
        allowToAdd: 'allowToAdd',
        allowToEdit: 'allowToEdit',
        allowToDelete: 'allowToDelete',
    },
    supportTeamsManagement: {
        allowToAdd: 'allowToAdd',
        allowToEdit: 'allowToEdit',
        allowToDelete: 'allowToDelete',
    },
    hcpManagement: {
        allowToTransfer: 'allowToTransfer',
        allowToViewHcpInfo: 'allowToViewHcpInfo',
        allowToViewHcpRole: 'allowToViewHcpRole',
        allowToAssignHcpRole: 'allowToAssignHcpRole',
        allowToDeleteHcpRole: 'allowToDeleteHcpRole',
        allowToViewHcpPatient: 'allowToViewHcpPatient',
        allowToAssignNewHcpPatient: 'allowToAssignNewHcpPatient',
        allowToRemoveHcpPatient: 'allowToRemoveHcpPatient',
        allowToViewHcpStaticList: 'allowToViewHcpStaticList',
        allowToAddNewHcpStaticList: 'allowToAddNewHcpStaticList',
        allowToRemoveHcpStaticList: 'allowToRemoveHcpStaticList',
        allowToViewHcpSupportTeams: 'allowToViewHcpSupportTeams',
    },
    patientManagement: {
        allowToAdd: 'allowToAdd',
        allowToEdit: 'allowToEdit',
        allowToAssignHcp: 'allowToAssignHcp',
        allowToAssignPathway: 'allowToAssignPathway',
        allowToAssignStaticList: 'allowToAssignStaticList',
        allowToViewPatientInfo: 'allowToViewPatientInfo',
        allowToViewObservations: 'allowToViewObservations',
        allowToViewSummary: 'allowToViewSummary',
        allowToAddObservations: 'allowToAddObservations',
        allowToViewParameters: 'allowToViewParameters',
        allowToAddParameters: 'allowToAddParameters',
        allowToViewActivities: 'allowToViewActivities',
        allowToAddBiometrics: 'allowToAddBiometrics',
        allowToViewSymptoms: 'allowToViewSymptoms',
        allowToViewReminders: 'allowToViewReminders',
        allowToAddReminders: 'allowToAddReminders',
        allowToViewNotes: 'allowToViewNotes',
        allowToAddNotes: 'allowToAddNotes',
        allowToViewExaminations: 'allowToViewExaminations',
        allowToAddExaminations: 'allowToAddExaminations',
        allowToViewRelevantContacts: 'allowToViewRelevantContacts',
        allowToAddRelevantContacts: 'allowToAddRelevantContacts',
        allowToViewDischargeInfo: 'allowToViewDischargeInfo',
        allowToDischargePatient: 'allowToDischargePatient',
        allowToViewWatchConfig: 'allowToViewWatchConfig',
        allowToUpdateWatchConfig: 'allowToUpdateWatchConfig',
        qualified: 'qualified',
    },
}

//#endregion
